import { useFirebase } from 'components/Firebase/index.js';
import { ONE_TO_ONE_PRODUCT } from 'constants/products.js';
import { useFeatureContext } from 'contexts/FeatureContext.jsx';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { handleCall } from 'utils/index.js';

const useGroupManager = ({ orgId, selectedProduct }) => {
  const firebase = useFirebase();
  const userId = useSelector(state => state.sessionState.authUser?.uid);
  const { features: { groupsEnabled, callsEnabled } } = useFeatureContext();
  const enabled = groupsEnabled && callsEnabled && selectedProduct === ONE_TO_ONE_PRODUCT && !!userId;
  const { data } = useQuery({
    queryKey: [`/o/${orgId}/groupManagers/${userId}`, { enabled }],
    queryFn: async () => {
      if (!enabled) return false;
      const agent = await firebase.getAgent();
      const { error, body: { uid } = {} } = await handleCall(agent, { url: `/o/${orgId}/groupManagers/${userId}` });
      if (error) return false;
      return !!uid;
    },
  });
  return { isGroupManager: data };
};

export default useGroupManager;
